export default __webpack_public_path__ + "static/media/kid19.2284dc4a.jpg";